import p, { keyframes as d } from "styled-components";
import "../themes/AtriusDark.js";
import "../themes/AtriusLight.js";
import "../themes/DistechDark.js";
import u from "../themes/DistechLight.js";
import "../themes/DLNLight.js";
function g(t) {
  if (t === "transparent")
    return t;
  const e = t.charAt(0) === "#" ? t.slice(1) : t;
  let r;
  if (/^([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i.test(e)) {
    let n = e;
    (e.length === 3 || e.length === 4) && (n = `${e[0]}${e[0]}${e[1]}${e[1]}${e[2]}${e[2]}${e.length === 4 ? `${e[3]}${e[3]}` : ""}`), r = {
      r: parseInt(n.slice(0, 2), 16),
      g: parseInt(n.slice(2, 4), 16),
      b: parseInt(n.slice(4, 6), 16),
      a: n.length === 8 ? parseInt(n.slice(6, 8), 16) : void 0
    };
  }
  return r;
}
function k(t) {
  let e = g(t);
  return e && (e = `rgb(${e.r}, ${e.g}, ${e.b})`), e;
}
function s(t, e = 1) {
  if (t === "transparent")
    return t;
  let r = g(t);
  return r && (r = `rgba(${r.r}, ${r.g}, ${r.b}, ${e})`), r;
}
const f = d([
  "from{opacity:0;}to{opacity:1;}"
]), w = p.div.withConfig({
  displayName: "FadeIn"
})([
  "width:100%;height:100%;animation:",
  " 1s;"
], f), a = {
  normal: "normal",
  plain: "plain",
  good: "good",
  attention: "attention",
  metric: "metric",
  caution: "caution",
  marketing: "marketing"
}, I = (t, e) => {
  let r = t.primaryFill;
  return e === "error" ? r = t.caution : e === "info" ? r = t.primaryFill : e === "success" ? r = t.good : e === "warning" && (r = t.metric), r;
}, l = (t, e, r) => {
  let n = r || t.text.primary;
  return e === a.normal ? n = t.primaryFill : e === a.plain ? n = t.plain : e === a.good ? n = t.good : e === a.attention ? n = t.attention : e === a.metric ? n = t.metric : e === a.caution ? n = t.caution : e === a.marketing ? n = t.marketing : e != null && e.startsWith("#") && (n = e), n;
}, m = 0.65, y = 0.85, c = (t, e = !1) => t === a.normal ? 1 : e ? y : m, o = {
  extraSmall: "extraSmall",
  small: "small",
  medium: "medium",
  large: "large",
  extraLarge: "extraLarge",
  superExtraLarge: "superExtraLarge"
}, i = {
  normal: "normal",
  outlined: "outlined",
  contained: "contained"
}, B = (t) => {
  let e = "34px";
  return t === o.extraSmall ? e = "20px" : t === o.small ? e = "24px" : t === o.large ? e = "40px" : t === o.extraLarge ? e = "46px" : t === o.superExtraLarge && (e = "56px"), e;
}, F = (t, e) => {
  let r = 16, n = !1;
  return t === o.extraSmall || t === o.small ? r = 12 : t === o.large ? (r = 20, n = !0) : t === o.extraLarge ? (r = 24, n = !0) : t === o.superExtraLarge && (r = 30, n = !0), e === i.normal && n && (r += 4), `${r}px`;
}, H = (t) => {
  let e = "8px";
  return t === o.extraSmall || t === o.small ? e = "4px" : t === o.superExtraLarge && (e = "12px"), e;
}, D = (t) => {
  const e = u;
  let { fontSize: r } = e.typography.body200;
  return t === o.extraSmall || t === o.small ? r = e.typography.body100.fontSize : t === o.large ? r = e.typography.body300.fontSize : t === o.extraLarge ? r = e.typography.body400.fontSize : t === o.superExtraLarge && (r = e.typography.body500.fontSize), r;
}, E = (t, e, r) => {
  let n = l(t, r);
  return e === i.contained && (n = t.colors.white), n;
}, P = (t, e, r) => {
  let n = "transparent";
  return e === i.contained && (n = l(t, r)), n;
}, h = (t, e, r) => {
  let n = "transparent";
  return e === i.outlined && (n = l(t, r)), n;
}, O = (t, e, r) => {
  let n = s(l(t, r), c(r, !1));
  return r === a.normal && (n = t.primaryHover), e === i.contained && (n = t.colors.white), n;
}, R = (t, e, r) => {
  let n = "transparent";
  return e === i.contained && (r === a.normal ? n = t.primaryHover : n = s(l(t, r), c(r, !1))), n;
}, T = (t, e, r) => {
  let n = "transparent";
  return e === i.outlined && (r === a.normal ? n = t.primaryHover : n = s(l(t, r), c(r, !1))), n;
}, A = (t, e, r) => {
  let n = s(l(t, r), c(r, !0));
  return r === a.normal && (n = t.primarySelected), e === i.contained && (n = t.colors.white), n;
}, N = (t, e, r) => {
  let n = "transparent";
  return e === i.contained && (r === a.normal ? n = t.primarySelected : n = s(l(t, r), c(r, !0))), n;
}, V = (t, e, r) => {
  let n = "transparent";
  return e === i.outlined && (r === a.normal ? n = t.primarySelected : n = s(l(t, r), c(r, !0))), n;
}, W = (t, e) => {
  let r = t.secondaryDisabled;
  return (e === i.outlined || e === i.contained) && (r = t.secondaryDisabled), r;
}, j = (t, e) => {
  let r = "transparent";
  return (e === i.outlined || e === i.contained) && (r = t.primaryDisabled), r;
}, q = (t, e) => {
  let r = "none";
  return e === "elevation" && (r = `0px 2px 8px 0px ${t.secondaryShadow}`), r;
};
export {
  w as FadeIn,
  y as darkOpacity,
  a as flavors,
  P as getBackground,
  j as getBackgroundDisabled,
  R as getBackgroundHover,
  N as getBackgroundPress,
  h as getBorderColor,
  T as getBorderColorHover,
  V as getBorderColorPress,
  E as getColor,
  W as getColorDisabled,
  O as getColorHover,
  A as getColorPress,
  l as getFlavorColor,
  D as getFontSize,
  F as getIconSize,
  c as getOpacity,
  H as getPadding,
  q as getShadow,
  B as getSize,
  I as getStatusColor,
  k as hexToRgb,
  s as hexToRgba,
  m as lightOpacity,
  o as sizes,
  i as variants
};
